module.exports = __webpack_public_path__ + "static/media/mastercard-logo.155f1040.svg";